import { CombinedJobInterface } from "../../interfaces/interfaces";
import { DateTime } from "luxon";
import { JobContainerProxy } from "@me-team/host/main/graphql/types";

const MAX_DISPLAYED_JOBS = 10;

class LoadingStatusService {
    public static combinedAndSortedJobService = (jobs: JobContainerProxy): CombinedJobInterface[] => {
        const combinedJob: Array<CombinedJobInterface> = [];
        if (jobs.importJobs.length !== 0) {
            jobs.importJobs.forEach((importJob) => combinedJob.push(importJob));
        }
        if (jobs.exportJobs.length !== 0) {
            jobs.exportJobs.forEach((exportJob) => combinedJob.push(exportJob));
        }
        if (jobs.storageReportJobs.length !== 0) {
            jobs.storageReportJobs.forEach((storageReportJob) => combinedJob.push(storageReportJob));
        }

        const format = "yyyy-MM-dd HH:mm:ss";
        const parseDate = (dateString: string) => DateTime.fromFormat(dateString, format);

        return combinedJob
            .sort((a, b) => {
                const dateA = parseDate(a.createdAt);
                const dateB = parseDate(b.createdAt);
                return dateB.toMillis() - dateA.toMillis();
            })
            .slice(0, MAX_DISPLAYED_JOBS);
    };
}

export default LoadingStatusService;
